// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isDate/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isDateWithOptions = convertToFP(fn, 2);
export default isDateWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isDateWithOptions/index.js
// module id = 921
// module chunks = 0